<template>
    <div class="container">
      <HeaderComponent app_title="NEOBUQ" />
      <main class="m-6">
        <NeobuqShipsTable class="table"></NeobuqShipsTable>
      </main>
      <FooterComponent class="footer bottom-0"></FooterComponent>
    </div>
  </template>
  
<script>
// @ is an alias to /src
import FooterComponent from "@/components/FooterComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import NeobuqShipsTable from "@/components/Neobuq/NeobuqShipsTable.vue";

export default {
    name: "NeobuqHomeView",
    components: {
        HeaderComponent,
        FooterComponent,
        NeobuqShipsTable,
    },
    created() {},
};
</script>


<style scoped>
  body{
      min-height: 100vh;
      display: flex;
      flex-direction: column;
  }
  #content-wrap {
    padding-bottom: 2.5rem;    /* Footer height */
  }
  
  #footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 9rem;         
    background-color: white;   /* Footer height */
  }
  
  #table {
    margin-bottom: 13rem;            /* Footer height */
  }
</style>